import React from "react";
import { motion } from "framer-motion";

export default function EventStaffingAboutClient() {
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.65, ease: [0.25, 0.1, 0.25, 1] },
    },
  };

  const listContainerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.15,
      },
    },
  };

  const listItemVariantsReq = {
    hidden: { opacity: 0, x: 28 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.45, ease: [0.25, 0.1, 0.25, 1] },
    },
  };

  const listItemVariantsChal = {
    hidden: { opacity: 0, x: -28 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.45, ease: [0.25, 0.1, 0.25, 1] },
    },
  };

  const requirementsList = [
    "Central platform for casino-party staffing management",
    "Role-based experience for administrators and dealers",
    "Manage parties, games, positions, and dealer assignments",
    "Handle invitations, open roles, and assignment approvals",
    "View upcoming assignments and complete event details",
    "Support structured booking and game-specific staffing",
    "Track assignment status from party creation to final roster management",
  ];

  const challengesList = [
    "Manual coordination made dealer scheduling difficult to scale",
    "No central view for invitations, open roles, and assignments",
    "Assignment approvals relied on constant back-and-forth communication",
    "Event details were fragmented across multiple messages",
    "Availability and role confirmations required manual follow-ups",
    "More events created greater coordination overhead and staffing risks",
    "No streamlined flow for managing the complete staffing process",
  ];

  return (
    <section className="es-about-client-wrapper">
      <div className="container-fluid horizontal-padding">
        {/* 1. About the Client Header & Meta */}
        {/* <div className="row align-items-center mb-5 pb-lg-3 mx-0">
          <div className="col-12 col-md-7 mb-4 mb-md-0">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={fadeInUp}
            >
              <h2 className="es-section-title">About the Client</h2>
              <p
                className="es-section-subtitle mb-2"
                style={{ color: "#ffffff", fontWeight: 500 }}
              >
                Casino-night operations at real event scale.
              </p>
              <p className="es-section-subtitle" style={{ maxWidth: "560px" }}>
                GSH Casino Parties is a Chicago-area event entertainment company
                delivering full casino-night setups, including blackjack, poker,
                roulette, and more, for corporate events, fundraisers, private
                parties, and celebrations.
              </p>

              <div className="es-client-info-meta">
                <div className="es-meta-item">
                  <span className="es-meta-label">Business Name : </span>
                  <span className="es-meta-value">GSH Casino Parties</span>
                </div>
                <div className="es-meta-item">
                  <span className="es-meta-label">Industry : </span>
                  <span className="es-meta-value">
                    Event Entertainment &amp; Staffing
                  </span>
                </div>
                <div className="es-meta-item">
                  <span className="es-meta-label">Region : </span>
                  <span className="es-meta-value">USA</span>
                </div>
              </div>
            </motion.div>
          </div>

          <div className="col-12 col-md-5 d-flex justify-content-center justify-content-md-end">
            <motion.div
              className="es-client-logo-card"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6 }}
            >
              <img
                src="/images/event-staffing/event-staffing-client-logo.png"
                alt="EventStaffing Client Logo"
                className="es-client-logo-img"
                loading="lazy"
              />
            </motion.div>
          </div>
        </div> */}

        {/* 2. Client Requirements Block */}
        <div className="row align-items-center es-req-chal-block es-req-block">
          <div className="col-12 col-lg-6 mb-4 mb-lg-0 d-flex justify-content-center justify-content-lg-center align-items-center">
            <motion.div
              className="es-illustration-wrap"
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.75, ease: [0.25, 0.1, 0.25, 1] }}
            >
              {/* Pulsing ambient gold glow */}
              <motion.div
                className="es-illustration-glow"
                animate={{
                  opacity: [0.35, 0.7, 0.35],
                  scale: [0.95, 1.05, 0.95],
                }}
                transition={{
                  duration: 4.5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              />

              {/* Gentle floating motion */}
              <motion.div
                className="es-illustration-float"
                animate={{ y: [-7, 7, -7] }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                whileHover={{ scale: 1.025, y: -4 }}
              >
                <img
                  src="/images/event-staffing/event-staffing-client-req.png"
                  alt="Client Requirements Illustration"
                  className="es-illustration-img"
                  loading="lazy"
                />
              </motion.div>
            </motion.div>
          </div>

          <div className="col-12 col-lg-6 ps-lg-4 ps-xl-5">
            <div className="es-content-wrap">
              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={fadeInUp}
              >
                <h3 className="es-list-heading">
                  Client Requirements
                  <motion.span
                    className="es-heading-gold-line"
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    viewport={{ once: true }}
                    transition={{
                      duration: 0.7,
                      ease: [0.25, 0.1, 0.25, 1],
                      delay: 0.2,
                    }}
                  />
                </h3>
              </motion.div>

              <motion.ul
                className="es-feature-list"
                variants={listContainerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
              >
                {requirementsList.map((item, idx) => (
                  <motion.li
                    key={idx}
                    variants={listItemVariantsReq}
                    className="es-feature-list-item"
                  >
                    {item}
                  </motion.li>
                ))}
              </motion.ul>
            </div>
          </div>
        </div>

        {/* 3. Client Challenges Block */}
        <div className="row align-items-center es-req-chal-block es-chal-block">
          <div className="col-12 col-lg-6 pe-lg-4 pe-xl-5 order-2 order-lg-1">
            <div className="es-content-wrap">
              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={fadeInUp}
              >
                <h3 className="es-list-heading">
                  Client Challenges
                  <motion.span
                    className="es-heading-gold-line"
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    viewport={{ once: true }}
                    transition={{
                      duration: 0.7,
                      ease: [0.25, 0.1, 0.25, 1],
                      delay: 0.2,
                    }}
                  />
                </h3>
              </motion.div>

              <motion.ul
                className="es-feature-list"
                variants={listContainerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
              >
                {challengesList.map((item, idx) => (
                  <motion.li
                    key={idx}
                    variants={listItemVariantsChal}
                    className="es-feature-list-item"
                  >
                    {item}
                  </motion.li>
                ))}
              </motion.ul>
            </div>
          </div>

          <div className="col-12 col-lg-6 mb-4 mb-lg-0 order-1 order-lg-2 d-flex justify-content-center justify-content-lg-center align-items-center">
            <motion.div
              className="es-illustration-wrap"
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.75, ease: [0.25, 0.1, 0.25, 1] }}
            >
              {/* Pulsing ambient gold glow */}
              <motion.div
                className="es-illustration-glow"
                animate={{
                  opacity: [0.35, 0.7, 0.35],
                  scale: [0.95, 1.05, 0.95],
                }}
                transition={{
                  duration: 4.8,
                  repeat: Infinity,
                  ease: "easeInOut",
                  delay: 0.5,
                }}
              />

              {/* Gentle floating motion */}
              <motion.div
                className="es-illustration-float"
                animate={{ y: [7, -7, 7] }}
                transition={{
                  duration: 5.2,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                whileHover={{ scale: 1.025, y: -4 }}
              >
                <img
                  src="/images/event-staffing/event-staffing-client-chal.png"
                  alt="Client Challenges Illustration"
                  className="es-illustration-img"
                  loading="lazy"
                />
              </motion.div>
            </motion.div>
          </div>
        </div>

        {/* 4. SprigStack Solution Box */}
        <motion.div
          className="es-solution-card"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
        >
          <div className="row align-items-center">
            <div className="col-12 col-lg-7 mb-4 mb-lg-0 pe-lg-4">
              <h3 className="es-solution-title">SprigStack Solution</h3>

              <div className="es-solution-highlight">
                <span className="es-gold-text fw-bold me-2">-</span>
                A purpose-built staffing system, not another generic scheduler
              </div>

              <p className="es-solution-text">
                SprigStack built EventStaffing.net around the casino-party
                staffing lifecycle, bringing parties, games, dealer profiles,
                assignments, approvals, rosters, and operational information
                into one centralized web platform.
              </p>

              <p className="es-solution-text mb-0">
                The solution separates administrative and dealer experiences
                while keeping both sides connected through the same staffing
                workflow.
              </p>
            </div>

            <div className="col-12 col-lg-5 text-center position-relative">
              {/* Subtle ambient glow behind solution mockup */}
              <motion.div
                className="es-solution-glow"
                animate={{
                  opacity: [0.35, 0.65, 0.35],
                  scale: [0.95, 1.05, 0.95],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              />

              <motion.div
                animate={{ y: [-5, 5, -5] }}
                transition={{
                  duration: 5.5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                whileHover={{ scale: 1.02, y: -3 }}
              >
                <img
                  src="/images/event-staffing/event-staffing-solution.png"
                  alt="SprigStack Solution Responsive Screens"
                  className="es-solution-screens-img"
                  loading="lazy"
                />
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

